import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

/**
 * Service responsible for holding the current date format pattern returned from an API or store.
 * Default provided is MM/DD/YYYY but can be updated at runtime.
 */
@Injectable({ providedIn: 'root' })
export class DateFormatService {
  private readonly formatSubject = new BehaviorSubject<string>('MM/DD/YYYY');

  /** Observable emitting current date format pattern */
  format$(): Observable<string> {
    return this.formatSubject.asObservable();
  }

  /** Current format value */
  get currentFormat(): string {
    return this.formatSubject.value;
  }

  /** Update the format (call this after API/store value is retrieved). Method used by runtime configuration flows. */
  setFormat(format: string): void {
    if (format && format !== this.formatSubject.value) {
      this.formatSubject.next(format);
    }
  }
}
